<div class="wrap-tag" data-aos="fade-up">
    <img class="cross-icn-blue" [src]="baseElementURL + 'blue-tag.png'">
</div>
<div class="bkg">
    <div class="header" data-aos="zoom-in-up">קריאות התפעלות ששלחו אלינו המארגנים:</div>
    <div id="carouselSlides_part9" class="carousel slide" data-interval="false">

        <ol class="carousel-indicators top-indicators" id="top-indicators-div">
            <li data-target="#carouselSlides_part9"
                *ngFor="let frameContentIndicators of frameContents; let i = index; let isFirst = first"
                [ngClass]="{active:i==currentFrameContents}" [attr.data-slide-to]="i" class="indicator-content">
                <img [src]="baseURL + (i==currentFrameContents?frameContentIndicators.imgUrl: frameContentIndicators.imgColorUrl)"
                    [id]="'frameContents-part9' + i" (click)="scrollToById(i)" data-aos="flip-left">
            </li>
        </ol>

        <ol class="carousel-indicators">
            <li data-target="#carouselSlides_part9" *ngFor="let text of lstText;let i=index ;let isFirst = first"
                [attr.data-slide-to]="i" [ngClass]="{active:isFirst}"></li>
        </ol>

        <div class="carousel-inner">
            <div *ngFor="let text of lstText;let i=index;let isFirst = first" class="carousel-item"
                [ngClass]="{active:isFirst}">
                <div class="text-wraper">
                    <p class="text" [innerHtml]="text" data-aos="zoom-in-up">
                    </p>
                </div>
            </div>
        </div>

        <a class="carousel-control-prev" href="#carouselSlides_part9" role="button" data-slide="next">
            <span class="wrap-arrow">
                <span class="icon icon-new-arrow-left2"></span>
            </span>
        </a>
        <a class="carousel-control-next" href="#carouselSlides_part9" role="button" data-slide="prev">
            <span class="wrap-arrow">
                <span class="icon icon-new-arrow-right2"></span>
            </span>
        </a>
    </div>
</div>
<div class="wrap-tag" data-aos="fade-left">
    <img class="cross-icn-boom" [src]="baseElementURL + 'boom-5.png'">
</div>
<div class="wrap-tag" data-aos1="zoom-out-right">
    <img class="cross-icn-lamp" [src]="baseElementURL + 'lamp.png'">
</div>